var exports = {
  "bE": "FeedPostCard.module__post___YnlDYl",
  "J7": "FeedPostCard.module__pageVariant___YnlDYl",
  "KI": "FeedPostCard.module__avatarButton___YnlDYl",
  "CH": "FeedPostCard.module__authorButton___YnlDYl",
  "Mj": "FeedPostCard.module__moreButton___YnlDYl",
  "hP": "FeedPostCard.module__actionButton___YnlDYl",
  "rf": "FeedPostCard.module__body___YnlDYl",
  "wx": "FeedPostCard.module__header___YnlDYl",
  "Tc": "FeedPostCard.module__tag___YnlDYl",
  "vE": "FeedPostCard.module__timestamp___YnlDYl",
  "N1": "FeedPostCard.module__timestampLink___YnlDYl",
  "qR": "FeedPostCard.module__timestampBeforeMarker___YnlDYl",
  "m7": "FeedPostCard.module__publicMarker___YnlDYl",
  "HG": "FeedPostCard.module__followPill___YnlDYl",
  "gG": "FeedPostCard.module__followPillFollowing___YnlDYl",
  "Wm": "FeedPostCard.module__followHoverLabel___YnlDYl",
  "Ib": "FeedPostCard.module__followIdleLabel___YnlDYl",
  "Qs": "FeedPostCard.module__content___YnlDYl",
  "yn": "FeedPostCard.module__noOpen___YnlDYl",
  "$_": "FeedPostCard.module__media___YnlDYl",
  "o1": "FeedPostCard.module__actions___YnlDYl",
  "gE": "FeedPostCard.module__actionIcon___YnlDYl",
  "DC": "FeedPostCard.module__viewCount___YnlDYl",
  "hu": "FeedPostCard.module__likePop___YnlDYl",
  "bT": "FeedPostCard.module__feedLikePop___YnlDYl",
  "bR": "FeedPostCard.module__actionButtonActive___YnlDYl",
  "aB": "FeedPostCard.module__likeButton___YnlDYl",
  "xE": "FeedPostCard.module__actionsEnd___YnlDYl",
  "nK": "FeedPostCard.module__comments___YnlDYl",
  "eu": "FeedPostCard.module__commentComposer___YnlDYl",
  "gJ": "FeedPostCard.module__commentComposerInput___YnlDYl",
  "n3": "FeedPostCard.module__commentComposerAvatar___YnlDYl",
  "Im": "FeedPostCard.module__comment___YnlDYl",
  "GI": "FeedPostCard.module__blockedComment___YnlDYl",
  "I2": "FeedPostCard.module__commentBody___YnlDYl",
  "br": "FeedPostCard.module__commentText___YnlDYl",
  "NP": "FeedPostCard.module__commentHeader___YnlDYl",
  "H8": "FeedPostCard.module__commentMeta___YnlDYl",
  "aj": "FeedPostCard.module__commentLikes___YnlDYl",
  "XI": "FeedPostCard.module__commentMore___YnlDYl" + " " + "FeedPostCard.module__moreButton___YnlDYl",
  "yb": "FeedPostCard.module__commentHeart___YnlDYl",
  "fU": "FeedPostCard.module__repliesToggle___YnlDYl",
  "Lp": "FeedPostCard.module__commentBadge___YnlDYl",
  "H3": "FeedPostCard.module__commentAuthor___YnlDYl" + " " + "FeedPostCard.module__authorButton___YnlDYl",
  "h5": "FeedPostCard.module__status___YnlDYl",
  "jo": "FeedPostCard.module__sendButton___YnlDYl",
  "aO": "FeedPostCard.module__videoMedia___YnlDYl",
};

module.exports = exports;
